export const data = [
  {
    id: 1,
    name: "Eastern Mountain Sports",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/ems.png?alt=media&token=ee04b1cf-bd69-4316-afca-a4026d326690',
    description: `The most trusted source for outdoor apparel, gear & guidance for the outdoor adventurers.`,
    company: "EMS",
    stack: [
      "Javascript",
      "React",
      "Jest",
    ],
    links: [
      { id: 1, link: "https://ems.com", name: "web" },
    ],
  },
  {
    id: 2,
    name: "Bob's Stores",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/bobstores.png?alt=media&token=6ebab72b-13e0-4c74-895f-026b5187213f',
    description: `Bob’s Stores is your home for great deals on the footwear, workwear, teamwear and every day clothing your family always needs.`,
    company: "Bob's Stores",
    stack: [
      "Javascript",
      "React",
      "Jest",
    ],
    links: [
      { id: 1, link: "https://bobstores.com", name: "web" },
    ],
  },
  // {
  //   id: 3,
  //   name: "RN Project",
  //   image: images.ABEG,
  //   description: `Abeg is a peer-to-peer payment app that makes sending and receiving money easy, fast and fun

  //   There's also the social element where you can request funds, spilt bills, create and join giveaways
  //   `,
  //   company: "Abeg Technologies",
  //   stack: [
  //     "Javascript",
  //     "React",
  //     "React Native",
  //     "React Animated",
  //     "Jest",
  //     "Lottie",
  //   ],
  //   links: [
  //     { id: 1, link: "https://apps.apple.com/gm/app/abeg/id1532676793", name: "github" },
  //   ]
  // },
  {
    id: 4,
    name: "Pocket by Piggvest",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/abeg.png?alt=media&token=9281c5c6-0420-41aa-abf3-d0752a75a024',
    description: `Abeg is a peer-to-peer payment app that makes sending and receiving money easy, fast and fun

    There's also the social element where you can request funds, spilt bills, create and join giveaways
    `,
    company: "Abeg Technologies",
    stack: [
      "Javascript",
      "React",
      "React Native",
      "React Animated",
      "Jest",
      "Lottie",
    ],
    links: [
      { id: 1, link: "https://apps.apple.com/gm/app/abeg/id1532676793", name: "ios" },
      { id: 2, link: "https://play.google.com/store/apps/details?id=com.abegapp&hl=en&gl=US", name: "android" },
      { id: 3, link: "https://abeg.app", name: "web" },
    ],
  },
  {
    id: 5,
    name: "Sabertooth Poker Club",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/spc.png?alt=media&token=efb5ce39-c163-41b6-b128-3148fa0f20df',
    description: `3D fully immersive metaverse with a sustainable, Play-to-Earn economy for all NFT communities.`,
    company: "Sabertooth Poker Club",
    stack: ["Javascript", " React", "Pubnub", "AWS", "React Testing Library"],
    links: [
      { id: 1, link: "https://www.sabertoothpokerclub.com/", name: "web" },
    ],
  },
  {
    id: 6,
    name: "Quikah",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/quika.png?alt=media&token=6d0e3b6d-53d2-4fa3-9be3-366841157b64',
    description: `Quika is an appointment booking app for businesses and professional people. 
    Quika users can create to-do&#39;s, schedule appointments, manage events, get reminders and
    share their appointment details with their contacts. For a start (i.e. MVP), Quika will target event
    planners - who will use it to create events, schedule appointments on invitees Quika calendar
    and manages guests.`,
    company: "Quika",
    stack: [
      "Javascript/TypeScript",
      "React",
      "AWS",
      "React Testing Library",
      "Redux",
    ],
    links: [
      { id: 1, link: "https://quikah.com", name: "web" },
    ],
  },
  {
    id: 7,
    name: "Tellascape",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/tellascape.png?alt=media&token=ee7c10dd-8785-4c52-8ecb-5ac6362bde2f',
    description: `Tellascape is flipping the script on traditional social media by giving people a platform to seek real-world experiences, and share these moments in an authenticated fashion. Search the world near and far for things to do, or capture the memories closest to you.`,
    company: "Tellascape",
    stack: [
      "Javascript/TypeScript",
      "React",
      "React Native",
      "Firebase",
      "Jest",
      "Redux",
    ],
    links: [
      { id: 1, link: "https://apps.apple.com/us/app/tellascape/id1462461606", name: "ios" },
      { id: 2, link: "https://play.google.com/store/apps/details?id=com.ts.Tellascape&hl=en&gl=US", name: "android" },
    ],
  },
  // {
  //   id: 8,
  //   name: "Learnry",
  //   image: images.LEARNRY,
  //   description: `Learnry is an intuitive, powerful and yet very easy to use learning management system that helps participants learn, interact, practice, receive feedback and perform much better in their jobs`,
  //   company: "Learnry",
  //   stack: [
  //     "Javascript/TypeScript",
  //     "React",
  //     "Docker",
  //     "Digital Ocean",
  //     "React Testing Library",
  //     "Redux",
  //   ],
  //   links: [
  //     { id: 1, link: "https://learnry.com/", name: "web" },
  //   ],
  // },
  {
    id: 9,
    name: "mAudition",
    image: 'https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/mAudition.webp?alt=media&token=294f7e04-0cc4-4849-8a68-c9a33ab3e7c7',
    description: `mAudition is the platform trusted by talent scouts and corporate brands to discover unique talents for projects and social initiatives. We remove the problems of transportation, security  and logistics associated with hosting live auditions.`,
    company: "Learnry",
    stack: ["Javascript", "React Native", "React Testing Library", "Redux"],
    links: [
      { id: 1, link: "https://apps.apple.com/us/app/maudition/id1518647149", name: "ios" },
      { id: 2, link: "https://play.google.com/store/apps/details?id=com.workforcegroup.maudition&hl=en&gl=US", name: "android" },
      { id: 1, link: "https://www.maudition.com/", name: "web" },
    ],
  },
];
